import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import DehazeIcon from '@mui/icons-material/Dehaze';
// utils
import { bgBlur } from '../../utils/cssStyles';
// hooks
import useResponsive from '../../hooks/useResponsive';

import Searchbar from './Searchbar';
import ModuleRoleDropdown from './ModuleRoleDropdown';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import abeplLogo from "../../../../images/abeplLogo.png";
import Search from '../../../../preregcamps/searchbar/searchbar';
import { useData } from '../../../../App';
import { useTranslation } from 'react-i18next';
// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 72;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const logo = (
  <Box
    component="img"
    src={abeplLogo} alt="logo" loading='lazy'
    sx={{ width: 40, height: 40 }}
  />
);
// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav }) {
  const {t} = useTranslation();
  const URN = localStorage.getItem('urn')
  const isDesktop = useResponsive('up', 'lg');
  return (
    <StyledRoot>
      <StyledToolbar>
        {localStorage.getItem('loginStatus') === 'true' && <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <DehazeIcon />
        </IconButton>}
        {isDesktop ?
          <Typography sx={{ color: '#009A4E' }} variant='h6'>
            {t('main.title')}
          </Typography>
          : logo}
        <Box sx={{ flexGrow: 1 }} />

        {localStorage.getItem('loginStatus') === 'true' && <Stack sx={{ minWidth: 0 }}
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
      { URN  ? null :  <ModuleRoleDropdown />}
          {/* <Searchbar /> */}
                  {/* <NotificationsPopover /> */}
           <NotificationsPopover/>
          <AccountPopover />
        </Stack>}
      </StyledToolbar>
    </StyledRoot>
  );
}
